import React from 'react';
import ResponsiveHeader from './ResponsiveHeader';
import HomeIndicatorIcon from '../icons/HomeIndicatorIcon';
import { useMetroConfig } from '../../contexts/MetroConfigContext';

export interface PageLayoutProps {
  children: React.ReactNode;
  headerTitle?: string;
  showSupport?: boolean;
  onSupportClick?: () => void;
  showMobileIndicator?: boolean;
  backgroundColor?: string;
  className?: string;
  showHeader?: boolean;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  headerTitle,
  showSupport = true,
  onSupportClick,
  showMobileIndicator = false,
  backgroundColor,
  className = '',
  showHeader = true,
}) => {
  const { metroConfig } = useMetroConfig();

  const canShowHeader = showHeader && !metroConfig.loading && !metroConfig.error && metroConfig.isLoaded;

  return (
    <div className={`min-h-screen flex flex-col ${backgroundColor ?? ''} ${className}`}>
      {canShowHeader && (
        <ResponsiveHeader
          title={headerTitle}
          showSupport={showSupport}
          onSupportClick={onSupportClick}
        />
      )}

      <main className="flex-1">
        {children}
      </main>

      {showMobileIndicator && (
        <div className="flex justify-center pb-2 md:hidden">
          <HomeIndicatorIcon width={139} height={5} color="#141414" />
        </div>
      )}
    </div>
  );
};

export default PageLayout;